import moment from "moment";
const getFormattedDateTime = (date) => {
  return moment(date).format("dddd MMM Mo YYYY, h:mm:ss a");
};
export { getFormattedDateTime };
